import { render, staticRenderFns } from "./CoPlanSelectConfigCustomiseModal.vue?vue&type=template&id=6073ee93&scoped=true&"
import script from "./CoPlanSelectConfigCustomiseModal.vue?vue&type=script&lang=ts&"
export * from "./CoPlanSelectConfigCustomiseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6073ee93",
  null
  
)

export default component.exports